import CmsBlogPostsApiV2 from 'api/v2/admins/cms-blog-posts-api-v2'
import { SelectSearchField } from 'components'
import React, { useState } from 'react'
import PropTypes from 'prop-types'


const propTypes = {
  name     : PropTypes.string,
  label    : PropTypes.string,
  required : PropTypes.bool
}

const defaultProps = {
  name     : '',
  label    : '',
  required : true
}

/**
 * Search field to select blog post by blog post title.
 * @param {string} name - Formik field name
 * @param {string} label - Field Label
 * @param {bool} required - It will show required badge if it set `true`
 */
const CmsBlogPostSelectSearchField = ({
  name,
  label,
  required,
  ...props
}) => {
  const [ searchBlogPosts, setSearchBlogPosts ] = useState([])
  const [ isSearchLoading, setSearchLoading ]   = useState(false)

  var blogPostSearchTimeout = null

  // search blog posts by similar title
  const getBlogPosts = async (title) => {
    setSearchLoading(true)
    const additionalFilters = {
      title: title
    }

    await CmsBlogPostsApiV2.get({ additionalFilters: additionalFilters })
      .then((response) => {
        setSearchBlogPosts(response.data.blogs)
        setSearchLoading(false)
      })
      .catch((error) => {
        alert(error.message)
      })
      .finally(() => setSearchLoading(false))
  }

  // The presentation of option label when dropdown is open
  const getOptionLabel = (option) => (
    <>
      <span className='mr-3'>{ option.id }</span>
      <span className='mr-3'>{ '-' }</span>
      <span className='mr-3'>{ option.title }</span>
    </>
  )

  // use to compare with Formik's value
  const getOptionValue = (option) => option.id

  // handler to search blog posts
  const handleSelectSearchOnChange = (event) => {
    const searchText = event.target.value
    if (blogPostSearchTimeout) clearTimeout(blogPostSearchTimeout)
    blogPostSearchTimeout = setTimeout(() => {
      getBlogPosts(searchText)
    }, 700)
  }

  return (
    <SelectSearchField
      type='text'
      name={ name }
      label={ label }
      placeholder='Search with Blog Post Title'
      dataList={ searchBlogPosts }
      onSearchChange={ handleSelectSearchOnChange }
      getOptionLabel={ getOptionLabel }
      getOptionValue={ getOptionValue }
      isLoading={ isSearchLoading }
      required={ required }
      { ...props }
    />
  )
}

CmsBlogPostSelectSearchField.propTypes    = propTypes
CmsBlogPostSelectSearchField.defaultProps = defaultProps

export default CmsBlogPostSelectSearchField
